<div class="card" *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS', 'READ']">
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="1"
        class="nav nav-tabs nav-tabs-custom"
      >
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <span class="d-block d-sm-none"
              ><i class="fas fa-toolbox"></i
            ></span>
            <span class="d-none d-sm-block">Utilidades</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabUtils"></ng-template>
          </ng-template>
        </li>
        <ng-container *ngIf="!apiServerProd || isLocalhost">
          <ng-container
            *appIsGranted="[
              'TOOLS_UTILS',
              'TOOLS_UTILS_EVENTS_SIMULATOR',
              'CREATE'
            ]"
          >
            <li [ngbNavItem]="2" (click)="initializeMap(false)">
              <a ngbNavLink>
                <span class="d-block d-sm-none"
                  ><i class="fas fa-strikethrough"></i
                ></span>
                <span class="d-none d-sm-block">Simular eventos</span>
              </a>
              <ng-template ngbNavContent>
                <ng-template
                  [ngTemplateOutlet]="TabGenerateEvent"
                ></ng-template>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
        <ng-container
          *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_SEARCH_GATEWAY', 'READ']"
        >
          <li [ngbNavItem]="3">
            <a ngbNavLink>
              <span class="d-block d-sm-none"
                ><i class="fas fa-cloud"></i
              ></span>
              <span class="d-none d-sm-block">Buscar Gateway</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabFindGateway"></ng-template>
            </ng-template></li
        ></ng-container>
        <ng-container
          *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_PARSE_AUX', 'READ']"
        >
          <li [ngbNavItem]="4">
            <a ngbNavLink>
              <span class="d-block d-sm-none"
                ><i class="fas fa-caret-up"></i
              ></span>
              <span class="d-none d-sm-block">ParserAux</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabParserAux"></ng-template>
            </ng-template></li
        ></ng-container>
        <ng-container
          *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_NEARBY_DEVICES', 'READ']"
        >
          <li [ngbNavItem]="5" (click)="initializeMap(true)">
            <a ngbNavLink>
              <span class="d-block d-sm-none"><i class="fas fa-map"></i></span>
              <span class="d-none d-sm-block">Dispositivos Próximos</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabDevicesNearby"></ng-template>
            </ng-template>
          </li>
        </ng-container>
        <ng-container
          *appIsGranted="[
            'TOOLS_UTILS',
            'TOOLS_UTILS_MOVIDA_EXPRESS_COMMANDS',
            'READ'
          ]"
        >
          <li [ngbNavItem]="6">
            <a ngbNavLink>
              <span class="d-block d-sm-none"
                ><i class="fas fa-smile"></i
              ></span>
              <span class="d-none d-sm-block">Comandos Movida Express</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template
                [ngTemplateOutlet]="TabMovidaExpressCmd"
              ></ng-template>
            </ng-template>
          </li>
        </ng-container>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>
  <!-- Tab Utils-->
  <ng-template #TabUtils>
    <div
      class="card m-3"
      *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_BREAK_LINES', 'CREATE']"
    >

      <div class="card-header">Quebra de linha para ;</div>
      <div class="input-group input-group-sm mb-2">
        <span class="input-group-text">SQL</span>
        <input
          #breakLineSQL
          type="checkbox"
          (change)="
            replaceBreakLineToDotPeriod(
              false,
              breakLineSQL.checked,
              breakLineInverted.checked
            )
          "
        />
      </div>
      <div class="input-group input-group-sm mb-2">
        <span class="input-group-text">Inverter</span>
        <input
          #breakLineInverted
          type="checkbox"
          (change)="
            replaceBreakLineToDotPeriod(
              false,
              breakLineSQL.checked,
              breakLineInverted.checked
            )
          "
        />
      </div>

      <div class="input-group input-group-sm mb-2">
        <span class="input-group-text">Entrada</span>
        <textarea
          style="width: 80%"
          [(ngModel)]="breakLineToDotPeriodInput"
          (ngModelChange)="
            replaceBreakLineToDotPeriod(
              false,
              breakLineSQL.checked,
              breakLineInverted.checked
            )
          "
        ></textarea>
      </div>
      <div class="input-group input-group-sm mb-2">
        <span class="input-group-text">Saída</span>
        <textarea
          style="width: 80%"
          [(ngModel)]="breakLineToDotPeriodOutput[0]"
          [disabled]="
            breakLineToDotPeriodOutput[0] == '' ||
            breakLineToDotPeriodOutput[0].length == 0
          "
        ></textarea>
        <div class="card m-2">
          <div>Total distintos {{ breakLineToDotPeriodOutput[2] }}</div>
          <div class="card m-1 d-inline">
            <div>
              {{ breakLineToDotPeriodOutput[1] }} duplicados
              <ng-container *ngIf="breakLineToDotPeriodOutput[1] != '0'">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  (click)="
                    replaceBreakLineToDotPeriod(
                      true,
                      breakLineSQL.checked,
                      breakLineInverted.checked
                    )
                  "
                >
                  Remover duplicados
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>

    <div
      class="card m-3"
      *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_SERIAL_VS_ICCID', 'READ']"
    >
    <div class="card-header">
        <h5>Lista de Serial vs ICCID na cache</h5>
      </div>
      <div class="card align-items-left">
        <div class="m-2" style="margin-left: 18px;"> 
        <div class="card-body"> 
          <button 
          type="button"
          class="btn btn-sm btn-primary"
          (click)="createCSVIccid()">Gerar CSV de Serial vs ICCID
          </button>
          </div> Permite gerar um relatório CSV 
          </div>
          </div>
          <div class="card-body">
              <button 
              type="button"
              class="btn btn-sm btn-primary"
              style="margin-left: 12px;"
              (click)="requestFilesCSVIccid()">Pesquisar Relatórios
              </button>
	          </div>
        <div class="m-2">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th class="text-center">Usuário</th>
                <th class="text-center">Id</th>
                <th class="text-center">Status</th>
                <th class="text-center">Data/Hora</th>
                <th class="text-center">Download</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of getPaginatedFiles()" class="align-middle py-0">
                <td class="text-center">{{ file.username }}</td>
                <td class="text-center">{{ file.id }}</td>
                <td class="text-center">{{ file.status }}</td>
                <td class="text-center">{{ file.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-success"
                          (click)="downloadFileCSV(file.id)"
                          [disabled]="file.status !== 'COMPLETED'">
                    CSV
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

            <!-- Controles de paginação -->
            <nav *ngIf="files.length > 0" class="mt-3 text-center">
              <button class="btn btn-outline-primary btn-sm me-2"
                (click)="changePage(currentPage - 1)"
                [disabled]="currentPage === 1">
                Anterior
              </button>
            <!-- <span>Página {{ currentPage }} de {{ totalPages }}</span> -->
              <button class="btn btn-outline-primary btn-sm ms-2"
                (click)="changePage(currentPage + 1)"
                [disabled]="currentPage === totalPages">
                Próxima
              </button>
            </nav>

          </div>
        </div>

    <div
      class="card m-3"
      *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_LORA_CACHE', 'READ']"
    >
      <div class="card-header">
        <h5>Pesquisa se o serial está na cache lora</h5>
      </div>
      <div
        class="card align-items-center"
        *ngIf="circularProgressiveWaitLoraCache"
      >
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <div class="row m-2">
        <div class="col-md-7">
          <input
            class="input w-100"
            [(ngModel)]="serialCacheLora"
            placeholder="Inserir os seriais separados por ;"
          />
        </div>
        <div class="col-md-5">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="getSerialCache()"
          >
            Pesquisar
          </button>

          <ng-container
            *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_LORA_CACHE', 'CREATE']"
          >
            <ng-container *ngIf="serialLoraIdCache.notFound.length > 0">
              <button
                class="btn btn-sm btn-success ms-2"
                (click)="openModalLoraCache(modalInsertLoraCache)"
              >
                Inserir na cache
              </button>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="m-2">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">Encontrado</th>
              <th class="text-center" scope="col">Não encontrado</th>
            </tr>
          </thead>
          <tbody>
            <td
              class="text-center word-wrap"
              scope="row"
              [innerText]="serialLoraIdCache.found"
            ></td>
            <td
              class="text-center word-wrap"
              scope="row"
              [innerText]="serialLoraIdCache.notFound"
            ></td>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card m-3"
    *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_FINDMY_CACHE', 'CREATE']">
      <div>
        <div class="card-header">
          <h5>Cache KEZPO FindMy - TAGS</h5> 
        </div>       
          <div class="row m-2">
            <div class="col-md-5">
              <input
                class="input w-100"
                [(ngModel)]="insertCacheFindMy"
                placeholder="Inserir somente o serial e depois Cadastrar Lista na Cache!"
                />
              </div>
              <div class="col-md-3">
                <button 
                  (click)="addListCacheFindMy(insertCacheFindMy)"
                  type="button"
                  class="btn btn-sm btn-primary">
                  Inserir na Lista
                </button>
                </div>
              <div *ngIf="messageListCacheFindMy" class="col-md-6">
                  {{ messageListCacheFindMy }}
                    </div>
              </div>
            <div class="row m-2">
              <div class="col-md-3">
                <button 
                  (click)="createCacheFindMy()"
                  type="button"
                  class="btn btn-sm btn-success">
                  Cadastrar Lista na Cache
                </button>
              </div>
                <div class="row" *ngIf="messageCreatListCacheFindMy">
                  <p>{{ messageCreatListCacheFindMy }}</p>
                    </div>                  
            </div>
            <div *ngIf="responseCreateListCacheFindMy.length > 0" 
              class="m-2">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th>Serial</th>
                    <th>Cadastrado</th>
                    <th>Erro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of responseCreateListCacheFindMy">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.cadastrado }}</td>
                    <td>{{ item.error }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row m-2">
              <div class="col-md-3">
                <h6>Upload de Planilha</h6>
                <input type="file" (change)="addListCacheFindMyLote($event)" accept=".xlsx, .xls" />
              </div>
            </div>
            <div>
              <div class="row m-2">
                <div class="col-md-3">
                  <button 
                    (click)="createCacheFindMyLote()"
                    type="button"
                    class="btn btn-sm btn-success">
                    Cadastrar em Lote
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="responseCreateListCacheFindMyLote.length > 0" 
              class="m-2">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th>Serial</th>
                    <th>Cadastrado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of responseCreateListCacheFindMyLote">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.cadastrado }}</td>
                  </tr>
                </tbody>
              </table>
            </div>  
          </div>    
          <div class="card-header">               
            </div>             
            <div class="row m-2"> 
              <h6>Verificar se está na Cache FindMy</h6>
                <div class="col-md-3">  
                  <input
                    class="input w-100"
                    [(ngModel)]="searchCacheFindMy"
                    placeholder="Números de série separados por ;"
                    /> 
                  </div> 
                  <div class="col-md-3">             
                    <button
                      (click)="pesquisarCacheFindMy()"
                      type="button"
                      class="btn btn-sm btn-primary">
                      Pesquisar na Cache
                    </button>
                  </div>
                </div> 
            <div *ngIf="responseSearchListCacheFindMy.length > 0" 
                class="m-2">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th>Serial</th>
                    <th>Existe</th>
                    <th>Data do Cadastro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of responseSearchListCacheFindMy">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.existe }}</td>
                    <td>{{ item.dataConvertida }}</td>
                  </tr>
                </tbody>
              </table>
            </div>         
          <div class="card-header">               
            </div>             
            <div class="row m-2"> 
                <h6>Remover da Cache FindMy</h6>   
              <div class="col-md-3">  
                <input
                  class="input w-100"
                  [(ngModel)]="removerCacheFindMy"
                  placeholder="Números de série separados por ;"
                  /> 
                </div>  
                <div class="col-md-3">             
                  <button
                    (click)="removeCacheFindMy()"
                    type="button"
                    class="btn btn-sm btn-primary">
                    Remover da Cache
                  </button>
                </div>
              </div> 
              <div *ngIf="responseRemoveListCacheFindMyLote.length > 0" 
                class="m-2">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th>Serial</th>
                    <th>Removido</th>
                    <th>Erro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of responseRemoveListCacheFindMyLote">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.removido }}</td>
                    <td>{{ item.error }}</td>
                  </tr>
                </tbody>
              </table>
            </div> 
        </div>

    <ng-container>
      <div
        class="card m-3"
        *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_CONSUMER_MAXTRACK', 'READ']"
      >
      <div class="card-header">
          <h5>Consumer Maxtrack</h5>      
          </div>
          <div class="card-header">
            <button 
              (click)="requestConsumer()"
              type="button"
              class="btn btn-sm btn-primary">
              Consultar Consumer Maxtrack
            </button>
          </div>
            <div *ngIf="consumer" style="margin-top: 20px;" class="card-body">
            <h5>Informações do Consumer</h5>
            <ul style="list-style: none; padding: 0;">
              <li><strong>Nome:</strong> {{ consumer.name }}</li>
              <li><strong>Ativa:</strong> {{ consumer.active }}</li>
              <li><strong>Status:</strong> {{ consumer.state }}</li>
              <li><strong>Consumers:</strong> {{ consumer.consumers }}</li>
              <li><strong>Quantidade na Fila:</strong> {{ consumer.ready }}</li>
              <li><strong>Não Confirmados:</strong> {{ consumer.unacknowledged }}</li>
              <li><strong>Taxa de Entrada/S:</strong> {{ consumer.getRate }}</li>
              <li><strong>Taxa de Consumo/S:</strong> {{ consumer.deliverRate }}</li>
              <li><strong>Taxa de Confirmação:</strong> {{ consumer.ackRate }}</li>
            </ul>
          </div>
      </div>
      </ng-container>    
       
    <ng-container>
      <div
        class="card m-3"
        *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_SERIAL_VS_ICCID', 'READ']"
      >
        <div class="card-header d-flex align-items-center justify-content-between">
          <h5 class="mb-0">Last Position</h5>
          <div class="d-flex gap-2">
            <!-- Input de arquivo estilizado -->
            <label class="btn btn-outline-primary btn-sm mb-0">
              Importar XLSX
              <input type="file" (change)="requestLastPosition($event)" accept=".xlsx" hidden />
            </label>

            <!-- Botão de envio -->
            <button class="btn btn-success btn-sm" (click)="sendListLastPosition()">
              Gerar Relatório
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      class="card m-3"
      *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_DUMP', 'READ']"
    >
      <div class="card-header">
        <h5>DUMP - Verifica se o serial está com o dump ativo</h5>
      </div>
      <div class="card align-items-center" *ngIf="circularProgressiveWaitDump">
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <div class="row m-2">
        <div class="col-md-5">
          <input
            class="input w-100"
            [(ngModel)]="seriaisDump"
            placeholder="Inserir os seriais separados por;"
          />
        </div>
        <div
          class="col-md-7"
          *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_DUMP', 'CREATE']"
        >
          <div class="col button-group">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="getSerialDump()"
              [disabled]="seriaisDump.length < 3 || seriaisDump == ''"
            >
              Pesquisar
            </button>
            <button
              type="button"
              class="btn btn-success btn-sm"
              (click)="addSerialDump()"
              [disabled]="seriaisDump.length < 3 || seriaisDump == ''"
            >
              Ativar Dump
            </button>
            <button class="btn btn-sm btn-primary" (click)="timeToDump = 86400">
              1dia
            </button>
            <button
              class="btn btn-sm btn-primary"
              (click)="timeToDump = 86400 * 3"
            >
              3dias
            </button>
            <button
              class="btn btn-sm btn-primary"
              (click)="timeToDump = 86400 * 7"
            >
              7dias
            </button>
            <button
              class="btn btn-sm btn-primary"
              (click)="timeToDump = 86400 * 30"
            >
              30dias
            </button>
          </div>
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Tempo para Dump(segundos) | {{ timeToDump / 86400 }} dias</span
            >
            <input
              class="form-control"
              type="number"
              step="3600"
              min="1800"
              max="2592000"
              [(ngModel)]="timeToDump"
              required
            />
          </div>
        </div>
      </div>
      <div class="m-2">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">Serial</th>
              <th class="text-center" scope="col">Status</th>
              <th class="text-center" scope="col">Tempo restante</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of seriaListDump">
              <tr>
                <td
                  class="text-center word-wrap"
                  scope="row"
                  [innerText]="item.serial"
                ></td>
                <td class="text-center word-wrap" scope="row">
                  {{ item.status }}
                  <ng-container *ngIf="item.status == 'Dump Ativo'">
                    <button
                      *ngIf="item.status == 'Dump Ativo'"
                      class="btn btn-sm btn-primary m-2"
                      (click)="getDump(item.serial)"
                    >
                      Abrir log
                    </button>
                  </ng-container>
                </td>
                <td
                  class="text-center word-wrap"
                  scope="row"
                  [innerText]="item.timeRemaining"
                ></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div
        class="card"
        *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_TEXT_TO_DUMP', 'CREATE']"
      >
        <div class="card-header">
          <h5>DUMP - Prepara texto para Dump no Gateway</h5>
        </div>
        <div class="row m-2 d-flex justify-content-around">
          <div class="col">
            <input
              #prepareTextToDumpSerial
              class="input w-100"
              placeholder="Inserir o serial"
              type="text"
            />
          </div>
          <div class="col">
            <div class="input-group input-group-sm mb-2">
              <span class="input-group-text">Fabricante </span>
              <ng-select
                class="w-50"
                placeholder="Selecione o fabricante"
                required
                [(ngModel)]="supplierPrepareToDumpSupplierSelect"
              >
                <ng-option value="maxtrack"> Maxtrack </ng-option>
                <ng-option value="mobilogix"> Mobilogix </ng-option>
                <ng-option value="bws"> Bws </ng-option>
                <ng-option value="suntech"> Suntech </ng-option>
                <ng-option value="allcom"> AllCom </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="
                prepareTextToDump(
                  prepareTextToDumpSerial.value,
                  supplierPrepareToDumpSupplierSelect
                )
              "
            >
              Preparar
            </button>
          </div>
          <div class="card text-center">
            <h6>{{ resultPrepareToDump }}</h6>
          </div>
        </div>
      </div>
      <ng-container
        *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_SEND_TO_DEV', 'CREATE']"
      >
        <ng-container *ngIf="apiServerProd">
          <div class="m-2">
            <div class="card">
              <div class="card-header">
                <h5>Enviar pacotes para o Ambiente de DEV</h5>
              </div>
              <div class="row d-flex justify-content-around">
                <div class="col-md-3">
                  <label>Serial</label>
                  <input
                    class="w-100"
                    placeholder="205502151"
                    [(ngModel)]="serialSendToDEV"
                  />
                </div>
                <div class="col-md-4">
                  <div>
                    <label>Data inicial</label>
                    <input
                      type="datetime-local"
                      step="1"
                      [(ngModel)]="dateStartSendToDEV"
                    />
                  </div>
                  <div>
                    <label class="me-2">Data Final</label>
                    <input
                      type="datetime-local"
                      step="1"
                      [(ngModel)]="dateEndSendToDEV"
                    />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Fabricante </span>
                    <ng-select
                      class="w-50"
                      placeholder="Selecione o fabricante"
                      [(ngModel)]="sendToDevPort"
                      required
                    >
                      <ng-option
                        *ngFor="let supplier of supplierSelectSendToDev"
                        [value]="supplier.port"
                      >
                        {{ supplier.name }} - {{ supplier.port }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="sendToDEV()"
                  >
                    Pesquisar
                  </button>
                </div>
              </div>
              <div
                class="card align-items-center"
                *ngIf="circularProgressiveWaitSendToDEV"
              >
                <div card="card-body">
                  <div class="spinner-border text-primary m-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!-- LaTEX table Test-->
    <div
      class="card"
      *appIsGranted="[
        'TOOLS_UTILS',
        'TOOLS_UTILS_TESTLINK_TABLE_TO_LATEX',
        'CREATE'
      ]"
    >
      <div class="card-header">
        Conversor da tabela de resultados do test link para LaTEX
      </div>
      <div class="card m-3">
        <div class="row">
          <div class="col-md-6">
            <textarea
              class="scrollabletextbox w-100"
              [(ngModel)]="textTableLatexOut"
            ></textarea>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <input
                class="form-control"
                type="file"
                id="file"
                accept=".odt"
                (change)="selectFileTableLaTEX($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="card m-3"
      *appIsGranted="['TOOLS_UTILS', 'TOOLS_UTILS_PEG', 'CREATE']"
    >
      <div class="card-header">PEG</div>
      <div class="card m-2">
        <textarea #pegInput> </textarea>
        <div class="row">
          <div class="col">
            <button class="btn btn-sm btn-primary" (click)="parsePEG(pegInput)">
              Gerar dados
            </button>
          </div>
          <div class="col">
            <div class="col input-group input-group-sm mb-2">
              <span class="input-group-text"
                >Usar nomenclatura<br />QUANDO SE ENTÃO</span
              >
              <input
                type="checkbox"
                class="ms-2 checkbox"
                [(ngModel)]="PEGFlagUseWHENIFTHENNomeclature"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th scope="col">Accumulador</th>
                <th scope="col">Item</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let accumulator of PEGAnalytic.Accumulators">
                <td scope="row">{{ getKey(accumulator) }}</td>
                <ng-container *ngIf="getValue(accumulator).length > 1">
                  <td>
                    <table>
                      <tbody>
                        <tr *ngFor="let value of getValue(accumulator)">
                          <td>{{ value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </ng-container>
                <ng-container *ngIf="getValue(accumulator).length == 1">
                  <td scope="row">{{ getValue(accumulator) }}</td></ng-container
                >
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th scope="col">Flags</th>
                <th scope="col">Item</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let flag of PEGAnalytic.Flags">
                <td scope="row">{{ getKey(flag) }}</td>
                <ng-container *ngIf="getValue(flag).length > 1">
                  <td>
                    <table>
                      <tbody>
                        <tr *ngFor="let value of getValue(flag)">
                          <td>{{ value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </ng-container>
                <ng-container *ngIf="getValue(flag).length == 1">
                  <td scope="row">{{ getValue(flag) }}</td></ng-container
                >
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col">
          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th scope="col">Pegs</th>
                <th scope="col">Item</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let peg of PEGAnalytic.Pegs">
                <td scope="row">{{ getKey(peg) }}</td>
                <ng-container *ngIf="getValue(peg).length > 1">
                  <td>
                    <table>
                      <tbody>
                        <tr *ngFor="let value of getValue(peg)">
                          <td>{{ value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </ng-container>
                <ng-container *ngIf="getValue(peg).length == 1">
                  <td scope="row">{{ getValue(peg) }}</td></ng-container
                >
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="card align-items-center"
        *ngIf="circularProgressiveWaitPEGMermaid"
      >
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="ms-2" style="text-align: end">
        <i
          class="fa fa-copy"
          style="cursor: pointer"
          (click)="copyToClipboard(PEGMemaidAux[0])"
          ngbTooltip="Copiar para área de transferência"
          aria-hidden="true"
        ></i>
      </div>
      <div class="card-body p-0 flex-grow overflow-auto text-base-content">
        <div class="flex-1 overflow-auto">
          <div id="view" class="p-2 h-full">
            <div
              id="container"
              style="height: 600px"
              class="h-full overflow-auto"
            >
              <div id="diagram"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Tab GenerateEvents-->
  <ng-template #TabGenerateEvent>
    <ng-container *ngIf="!apiServerProd || isLocalhost">
      <div class="card m-3">
        <div class="card-header">
          <h5>Simular evento</h5>
        </div>
        <div
          class="card align-items-center"
          *ngIf="circularProgressiveWaitLoraCache"
        >
          <div card="card-body">
            <div class="spinner-border text-primary m-1" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div class="row d-flex">
          <div class="row d-flex align-items-center">
            <div class="col">
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">Data Evento </span>
                <input
                  class="form-control"
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="newEvento.data_hora_evento"
                  required
                />
              </div>
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">Data Recebimento </span>
                <input
                  class="form-control"
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="newEvento.data_hora_evento"
                  required
                />
              </div>
            </div>
            <div class="col button-group">
              <ui-switch
                #operator
                class="ms-2"
                defaultBgColor="#F44336"
                defaultBoColor="#dfdfdf"
                color="#038edc"
                [checked]="true"
                uncheckedLabel="Menos"
                checkedLabel="Mais"
              ></ui-switch>
              <button
                class="btn btn-sm btn-primary"
                (click)="changeDateTimeGenerateEvent(operator, 180)"
              >
                3min
              </button>
              <button
                class="btn btn-sm btn-primary"
                (click)="changeDateTimeGenerateEvent(operator, 1800)"
              >
                30min
              </button>
              <button
                class="btn btn-sm btn-primary"
                (click)="changeDateTimeGenerateEvent(operator, 3600)"
              >
                60min
              </button>
              <button
                class="btn btn-sm btn-primary"
                (click)="changeDateTimeGenerateEvent(operator, 84600)"
              >
                1 dia
              </button>
              <button
                class="btn btn-sm btn-success"
                (click)="changeDateTimeGenerateEvent(operator, -1)"
              >
                Agora
              </button>
            </div>
          </div>
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">Número de Série </span>
            <input
              placeholder="Infome um serial"
              class="form-control"
              [(ngModel)]="newEvento.rastreador.numero_serie"
              required
            />
          </div>
          <!-- <div class="input-group input-group-sm mb-3">
          <span class="input-group-text">Fabricante </span>
          <ng-select
            class="w-50"
            placeholder="Selecione um fabricante"
            [(ngModel)]="newEvento.rastreador.fabricante"
            required
          >
            <ng-option
              *ngFor="let fabricante of eventProto.fabricante"
              [value]="fabricante.id"
            >
              {{ fabricante.name }}
            </ng-option>
          </ng-select>
        </div> -->
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">Tipo Evento </span>
            <ng-select
              class="w-50"
              placeholder="Selecione um evento"
              [(ngModel)]="newEvento.tipo_evento"
              required
            >
              <ng-option
                *ngFor="let events of eventProto.tipo_evento"
                [value]="events.id"
              >
                {{ events.name }}
              </ng-option>
            </ng-select>
          </div>
          <div>
            <div class="row">
              <div class="col input-group input-group-sm mb-2">
                <span class="input-group-text">Posição online</span>
                <ui-switch
                  class="ms-2"
                  defaultBgColor="#F44336"
                  defaultBoColor="#dfdfdf"
                  color="#038edc"
                  checkedLabel="True"
                  uncheckedLabel="False"
                  [(ngModel)]="newEvento.flags.posicao_online"
                ></ui-switch>
              </div>
              <div class="col input-group input-group-sm mb-2">
                <span class="input-group-text">Origem mensagem</span>
                <ng-select
                  class="w-50"
                  placeholder="Selecione uma origem"
                  [(ngModel)]="newEvento.origem_mensagem"
                  required
                >
                  <ng-option
                    *ngFor="let origem of eventProto.origem_mensagem"
                    [value]="origem.id"
                  >
                    {{ origem.name }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col input-group input-group-sm mb-2">
                <span class="input-group-text">Ignicao</span>
                <ui-switch
                  class="ms-2"
                  defaultBgColor="#F44336"
                  defaultBoColor="#dfdfdf"
                  color="#038edc"
                  checkedLabel="True"
                  uncheckedLabel="False"
                  [(ngModel)]="newEvento.flags.ignicao"
                ></ui-switch>
              </div>
              <div class="col input-group input-group-sm mb-2">
                <span class="input-group-text">Ignicao virtual</span>
                <ui-switch
                  class="ms-2"
                  defaultBgColor="#F44336"
                  defaultBoColor="#dfdfdf"
                  color="#038edc"
                  checkedLabel="True"
                  uncheckedLabel="False"
                  [(ngModel)]="newEvento.flags.ignicao_virtual"
                ></ui-switch>
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col">
                <label class="m-2">GPS</label>
                <button
                  type="button"
                  (click)="
                    changeValueButtonToggle(newEventoSupport.gps); addMarker()
                  "
                  [ngClass]="{
                    'btn btn-sm btn-primary': newEventoSupport.gps.use,
                    'btn btn-sm btn-secondary': !newEventoSupport.gps.use
                  }"
                >
                  Incluir
                </button>
                <ng-container *ngIf="newEventoSupport.gps.use">
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">GPS fixado</span>
                    <ui-switch
                      #buttonGps
                      class="ms-2"
                      defaultBgColor="#F44336"
                      defaultBoColor="#dfdfdf"
                      color="#038edc"
                      checkedLabel="True"
                      uncheckedLabel="False"
                      (change)="
                        changeValueButtonToggleValue(
                          newEventoSupport.gps.value,
                          buttonGps,
                          'fixado'
                        )
                      "
                    ></ui-switch>
                  </div>

                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Latitude</span>
                    <input
                      type="number"
                      class="form-control"
                      (ngModelChange)="changeMarker()"
                      [(ngModel)]="newEventoSupport.gps.value.latitude"
                      step="0.0001"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Longitude</span>
                    <input
                      class="form-control"
                      type="number"
                      (ngModelChange)="changeMarker()"
                      [(ngModel)]="newEventoSupport.gps.value.longitude"
                      step="0.0001"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Proa</span>
                    <input
                      class="form-control"
                      type="number"
                      (ngModelChange)="changeMarker()"
                      [(ngModel)]="newEventoSupport.gps.value.proa"
                      step="15"
                      max="360"
                      min="0"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Velocidade</span>
                    <input
                      class="form-control"
                      type="number"
                      [(ngModel)]="newEventoSupport.gps.value.velocidade"
                      step="1"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Odometro </span>
                    <input
                      placeholder="Infome o odometro"
                      class="form-control"
                      [(ngModel)]="newEventoSupport.gps.value.odometro"
                      required
                    />
                  </div>
                </ng-container>
              </div>
              <div class="col">
                <div class="row">
                  <div class="d-inline">
                    <label class="m-2">Bateria Externa</label>
                    <button
                      type="button"
                      (click)="
                        changeValueButtonToggle(
                          newEventoSupport.bateria_externa
                        )
                      "
                      [ngClass]="{
                        'btn btn-sm btn-primary':
                          newEventoSupport.bateria_externa.use,
                        'btn btn-sm btn-secondary':
                          !newEventoSupport.bateria_externa.use
                      }"
                    >
                      Incluir
                    </button>
                  </div>
                  <ng-container *ngIf="newEventoSupport.bateria_externa.use">
                    <div>
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text">Ativa</span>
                        <ui-switch
                          #buttonBatteryExternal
                          class="ms-2"
                          defaultBgColor="#F44336"
                          defaultBoColor="#dfdfdf"
                          color="#038edc"
                          checkedLabel="True"
                          uncheckedLabel="False"
                          (change)="
                            changeValueButtonToggleValue(
                              newEventoSupport.bateria_externa.value,
                              buttonBatteryExternal,
                              'ativa'
                            )
                          "
                        ></ui-switch>
                      </div>
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text">Tensão</span>
                        <input
                          class="form-control"
                          type="number"
                          [(ngModel)]="
                            newEventoSupport.bateria_externa.value.tensao
                          "
                        />
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="row">
                  <div class="d-inline">
                    <label class="m-2">Bateria Interna</label>
                    <button
                      type="button"
                      (click)="
                        changeValueButtonToggle(
                          newEventoSupport.bateria_interna
                        )
                      "
                      [ngClass]="{
                        'btn btn-sm btn-primary':
                          newEventoSupport.bateria_interna.use,
                        'btn btn-sm btn-secondary':
                          !newEventoSupport.bateria_interna.use
                      }"
                    >
                      Incluir
                    </button>
                  </div>
                  <ng-container *ngIf="newEventoSupport.bateria_interna.use">
                    <div>
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text">Ativa</span>
                        <ui-switch
                          #buttonBatteryInternal
                          class="ms-2"
                          defaultBgColor="#F44336"
                          defaultBoColor="#dfdfdf"
                          color="#038edc"
                          checkedLabel="True"
                          uncheckedLabel="False"
                          (change)="
                            changeValueButtonToggleValue(
                              newEventoSupport.bateria_interna.value,
                              buttonBatteryInternal,
                              'ativa'
                            )
                          "
                        ></ui-switch>
                      </div>
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text">Tensão</span>
                        <input
                          class="form-control"
                          type="number"
                          [(ngModel)]="
                            newEventoSupport.bateria_interna.value.tensao
                          "
                        />
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="col">
                <div class="d-inline">
                  <label class="m-2">GPIO's</label>
                  <button
                    #baterryExternal
                    type="button"
                    (click)="changeValueButtonToggle(newEventoSupport.portas)"
                    [ngClass]="{
                      'btn btn-sm btn-primary': newEventoSupport.portas.use,
                      'btn btn-sm btn-secondary': !newEventoSupport.portas.use
                    }"
                  >
                    Incluir
                  </button>
                </div>
                <ng-container *ngIf="newEventoSupport.portas.use">
                  <div>
                    <div class="row">
                      <label>Entrada</label>
                      <div class="input-group input-group-sm mb-2">
                        <div class="col input-group input-group-sm mb-2">
                          <span class="input-group-text">Tipo</span>
                          <ng-select
                            class="w-50"
                            placeholder="Selecione uma origem"
                            [(ngModel)]="
                              newEventoSupport.portas.value[0].tipo_portas
                            "
                            required
                          >
                            <ng-container *ngFor="let tipo of eventProto.tipo">
                              <ng-option
                                *ngIf="tipo.name == 'ENTRADA'"
                                [value]="tipo.id"
                              >
                                {{ tipo.name }}
                              </ng-option>
                            </ng-container>
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col input-group input-group-sm mb-2">
                          <span class="input-group-text">Equipamento</span>
                          <ng-select
                            class="w-50"
                            placeholder="Selecione uma origem"
                            [(ngModel)]="
                              newEventoSupport.portas.value[0].equipamento_porta
                            "
                            required
                          >
                            <ng-option
                              *ngFor="let equipamento of eventProto.equipamento"
                              [value]="equipamento.id"
                            >
                              {{ equipamento.name }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="input-group input-group-sm mb-2">
                          <span class="input-group-text">Porta</span>
                          <input
                            class="form-control"
                            type="number"
                            [(ngModel)]="
                              newEventoSupport.portas.value[0].numero_porta
                            "
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col input-group input-group-sm mb-2">
                          <span class="input-group-text">Valor saida</span>
                          <ng-select
                            class="w-50"
                            placeholder="Selecione uma origem"
                            [(ngModel)]="
                              newEventoSupport.portas.value[0].valor_saida
                            "
                            required
                          >
                            <ng-option
                              *ngFor="
                                let estado_saida of eventProto.estado_saida
                              "
                              [value]="estado_saida.id"
                            >
                              {{ estado_saida.name }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <label>Saída</label>
                      <div class="input-group input-group-sm mb-2">
                        <div class="col input-group input-group-sm mb-2">
                          <span class="input-group-text">Tipo</span>
                          <ng-select
                            class="w-50"
                            placeholder="Selecione uma origem"
                            [(ngModel)]="
                              newEventoSupport.portas.value[1].tipo_portas
                            "
                            required
                          >
                            <ng-container *ngFor="let tipo of eventProto.tipo">
                              <ng-option
                                *ngIf="tipo.name == 'SAIDA'"
                                [value]="tipo.id"
                              >
                                {{ tipo.name }}
                              </ng-option>
                            </ng-container>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col input-group input-group-sm mb-2">
                        <span class="input-group-text">Equipamento</span>
                        <ng-select
                          class="w-50"
                          placeholder="Selecione uma origem"
                          [(ngModel)]="
                            newEventoSupport.portas.value[1].equipamento_porta
                          "
                          required
                        >
                          <ng-option
                            *ngFor="let equipamento of eventProto.equipamento"
                            [value]="equipamento.id"
                          >
                            {{ equipamento.name }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text">Porta</span>
                        <input
                          class="form-control"
                          type="number"
                          [(ngModel)]="
                            newEventoSupport.portas.value[1].numero_porta
                          "
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col input-group input-group-sm mb-2">
                        <span class="input-group-text">Valor saida</span>
                        <ng-select
                          class="w-50"
                          placeholder="Selecione uma origem"
                          [(ngModel)]="
                            newEventoSupport.portas.value[1].valor_saida
                          "
                          required
                        >
                          <ng-option
                            *ngFor="let estado_saida of eventProto.estado_saida"
                            [value]="estado_saida.id"
                          >
                            {{ estado_saida.name }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="row">
            <div class="col-md-2">
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">UF</span>
                <ng-select
                  class="w-50"
                  placeholder="UF"
                  (change)="getCity($event)"
                >
                  <ng-option *ngFor="let uf of ufLst">
                    {{ uf }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div>
              <button
                class="btn btn-sm btn-primary"
                (click)="generateEvent()"
                [disabled]="
                  newEvento.rastreador.numero_serie == undefined ||
                  newEvento.tipo_evento == undefined
                "
              >
                Gerar evento
              </button>
              <label
                *ngIf="newEvento.rastreador.numero_serie == undefined"
                class="text-danger ms-3"
              >
                Preencha o número de série</label
              >
              <label
                *ngIf="newEvento.tipo_evento == undefined"
                class="text-danger ms-3"
              >
                Preencha o tipo de evento</label
              >
            </div>
            <div class="col-md-8">
              <div
                class="card align-items-center"
                *ngIf="circularProgressiveCity"
              >
                <div class="spinner-border text-primary m-1" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div *ngIf="!circularProgressiveCity && cityLst.length > 0">
                <div class="input-group input-group-sm mb-3">
                  <span class="input-group-text">UF</span>
                  <ng-select
                    class="w-75"
                    placeholder="Selecione uma cidade"
                    (change)="changeMapOnChangeCity($event)"
                  >
                    <ng-option *ngFor="let city of cityLst" [value]="city.name">
                      {{ city.name }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            <div id="map" [minHeight]="200" [fluidHeight]></div>
          </div>
          <div class="card m3">
            <label>Evento Gerado</label>
            <div
              *ngFor="let event of eventResult"
              class="card m-3"
              [ngStyle]="{
                'background-color': event.status == -1 ? 'red' : ''
              }"
            >
              {{ event.packet }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <div class="card m-3">
    <!-- Dialog Insert Lora Cache -->
    <ng-template #modalInsertLoraCache let-modal>
      <div class="modal-header">
        <h5 class="modal-title mt-0">Adicionar seriais e loraid na cache</h5>
        <button
          type="button"
          class="btn btn-close"
          (click)="modal.dismiss('Cross click')"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="card align-items-center"
          *ngIf="circularProgressiveWaitLoraCacheModalStatus"
        >
          <div card="card-body">
            <div class="spinner-border text-primary m-1" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div *ngFor="let serial of insertCacheLora">
          <div class="input-group input-group-sm mb-3">
            <span class="input-group-text" id="inputGroup-plate">{{
              serial.serial
            }}</span>
            <input
              [name]="serial.serial"
              [(ngModel)]="serial.loraId"
              type="number"
              class="form-control"
              required
              aria-describedby="inputGroup-loraid"
            />
          </div>
        </div>

        <!-- ADICIONAR BLOQUEIO PARA PARAMETROS NAO CONFIGURADOS -->
        <button
          type="submit"
          class="btn btn-primary"
          (click)="insertLoraCache(); modal.dismiss('Cross click')"
        >
          Adicionar
        </button>
      </div>
    </ng-template>
  </div>

  <!-- Tab FindGateway-->
  <ng-template #TabFindGateway>
    <div class="card">
      <div class="card-body column">
        <div class="row">
          <h6 class="card">Pesquisa gateway</h6>
          <div class="col-md-7">
            <label for="serial" class="col-md-2 col-form-label">Seriais</label>
            <input
              class="w-75"
              placeholder="205502151"
              [(ngModel)]="gatewaysSeriais"
            />
          </div>
          <div class="col-md-3">
            <div class="column">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right: 5px"
                (click)="searchGateway()"
              >
                Pesquisar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card align-items-center"
      *ngIf="circularProgressiveWaitSearchGateway"
    >
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header"><h6></h6></div>
      <div class="card-body">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">Gateway</th>
              <th class="text-center" scope="col">Data</th>
              <th class="text-center" scope="col">Serial</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of sortItem(gateways); let i = index">
              <td class="text-center" scope="row">{{ item.gateway }}</td>
              <td class="text-center" scope="row">
                {{ item.date }} - {{ item.dateWithoutConection }}
              </td>
              <td class="text-center" scope="row">{{ item.serial }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>

  <!-- Tab PaserAux-->
  <ng-template #TabParserAux>
    <div class="card">
      <div class="card-body column">
        <div class="row">
          <h6 class="card">Quebrar pacote</h6>
          <div class="col-md-7">
            <label for="serial" class="col-md-2 col-form-label">Pacote</label>
            <input
              #ParserAuxInput
              class="w-75"
              placeholder="[2023-07-20 19:20:42,T5,ALL=linksolutions.br:link:link:gw-dev.satrastreamento.com.br:9001:gw-dev.satrastreamento.com.br:9001:..."
            />
          </div>
          <div class="col-md-3">
            <div class="column">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right: 5px"
                (click)="breakPacket(ParserAuxInput)"
              >
                Quebrar pacote
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card align-items-center"
      *ngIf="circularProgressiveWaitSearchGateway"
    >
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card">
      <ng-container *ngIf="this.parser.parserPacket[0].value.length > 0">
        <div class="card-header"><h6></h6></div>
        <div class="card-body overflow-auto fit-content-if-not-overflow">
          <div class="d-block">
            <div class="input-group input-group-sm mb-2">
              <span class="input-group-text">Grupo </span>
              <ng-select
                placeholder="Selecione um grupo"
                [multiple]="true"
                [(ngModel)]="this.parser.parserPacket[0].filterGroup"
              >
                <ng-option
                  *ngFor="
                    let group of returnDistinct(
                      this.parser.parserPacket[0].paramGroup
                    )
                  "
                  [value]="group"
                >
                  {{ group }}</ng-option
                >
              </ng-select>
            </div>
            <div class="input-group input-group-sm mb-2">
              <span class="input-group-text">Param </span>
              <ng-select
                placeholder="Selecione um parâmetro"
                [multiple]="true"
                [(ngModel)]="this.parser.parserPacket[0].filterParam"
              >
                <ng-option
                  *ngFor="let param of this.parser.parserPacket[0].param"
                  [value]="param"
                >
                  {{ param }}</ng-option
                >
              </ng-select>
            </div>
          </div>

          <table class="table table-fit table-bordered table-hover">
            <thead class="table-primary">
              <tr>
                <th class="text-center" scope="col">Grupo</th>
                <th class="text-center" scope="col">Parametro</th>
                <ng-container
                  *ngFor="
                    let subItem of filterBreakPacket(
                      this.parser.parserPacket[0]
                    ).value;
                    let row = index
                  "
                >
                  <th class="text-center" scope="col">
                    Valor{{ row + 1 }}
                    <i
                      class="fa fa-remove"
                      aria-hidden="true"
                      style="cursor: pointer; color: red"
                      (click)="removeItemPacket(0, row)"
                      >x</i
                    >
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="
                  let item of filterBreakPacket(this.parser.parserPacket[0])
                    .param;
                  let row = index
                "
              >
                <tr>
                  <td class="text-center" scope="row">
                    {{
                      filterBreakPacket(this.parser.parserPacket[0]).paramGroup[
                        row
                      ]
                    }}
                  </td>
                  <td
                    class="text-center"
                    scope="row"
                    (dblclick)="
                      filterBreakPacket(this.parser.parserPacket[0]).paramGroup[
                        row
                      ] == 'PACOTE'
                        ? copyToClipboard(
                            filterBreakPacket(this.parser.parserPacket[0])
                              .packet[row]
                          )
                        : null
                    "
                  >
                    {{
                      filterBreakPacket(this.parser.parserPacket[0]).param[row]
                    }}
                  </td>
                  <ng-container
                    *ngFor="
                      let subItem of filterBreakPacket(
                        this.parser.parserPacket[0]
                      ).value;
                      let column = index
                    "
                  >
                    <td
                      [ngClass]="{
                        'max-width-first-line':
                          filterBreakPacket(this.parser.parserPacket[0])
                            .paramGroup[row] == 'PACOTE',
                        'text-center':
                          filterBreakPacket(this.parser.parserPacket[0])
                            .paramGroup[row] != 'PACOTE'
                      }"
                      scope="row"
                    >
                      {{ subItem[row] }}
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <!-- Tab TabDevicesNearby-->
  <ng-template #TabDevicesNearby>
    <div class="card m-3">
      <div class="card-header">
        <h5>Dispositivo próximos</h5>
      </div>
      <div
        class="card align-items-center"
        *ngIf="circularProgressiveWaitLoraCache"
      >
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="row d-flex">
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Latitude</span>
          <input
            [(ngModel)]="deviceNearbyMapLatLngRadius.lat"
            type="number"
            class="form-control"
            (ngModelChange)="clickMapDeviceNearby()"
            step="0.0001"
          />
        </div>
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Longitude</span>
          <input
            [(ngModel)]="deviceNearbyMapLatLngRadius.lng"
            class="form-control"
            type="number"
            (ngModelChange)="clickMapDeviceNearby()"
            step="0.0001"
          />
        </div>
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Raio (km)</span>
          <input
            class="form-control"
            type="number"
            [(ngModel)]="deviceNearbyMapLatLngRadius.radius"
            (change)="clickMapDeviceNearby()"
            step="1"
            min="0"
          />
        </div>

        <div>
          <button
            class="btn btn-sm btn-primary"
            (click)="
              searchDeviceNearby(
                deviceNearbyMapLatLngRadius.lat,
                deviceNearbyMapLatLngRadius.lng,
                deviceNearbyMapLatLngRadius.radius
              )
            "
            [disabled]="
              deviceNearbyMapLatLngRadius.lat == 0 ||
              deviceNearbyMapLatLngRadius.lng == 0 ||
              deviceNearbyMapLatLngRadius.lng == 0
            "
          >
            Pesquisar
          </button>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-md">
          <ng-select
            class="custom"
            id="eventTypeSelect"
            placeholder="Tipo evento"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="deviceNearbyFilter.deviceEventTypeDistinct"
            [searchable]="true"
            [multiple]="true"
            (change)="filterDeviceNearby()"
            [markFirst]="true"
          >
            <ng-option
              *ngFor="let eventType of deviceNearby.deviceEventTypeDistinct"
              [value]="eventType"
            >
              {{ eventType }}
            </ng-option>
          </ng-select>
        </div>
        <div class="col-md">
          <ng-select
            class="custom"
            id="originTypeSelect"
            placeholder="Origem Mensagem"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="deviceNearbyFilter.deviceMessageOriginDistinct"
            [searchable]="true"
            [multiple]="true"
            (change)="filterDeviceNearby()"
            [markFirst]="true"
          >
            <ng-option
              *ngFor="let origin of deviceNearby.deviceMessageOriginDistinct"
              [value]="origin"
            >
              {{ origin }}
            </ng-option>
          </ng-select>
        </div>
        <div class="col-md">
          <ng-select
            class="custom"
            id="deviceModelSelect"
            placeholder="Modelo dispositivo"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="deviceNearbyFilter.deviceModelDistinct"
            [searchable]="true"
            [multiple]="true"
            (change)="filterDeviceNearby()"
            [markFirst]="true"
          >
            <ng-option
              *ngFor="let deviceModel of deviceNearby.deviceModelDistinct"
              [value]="deviceModel"
            >
              {{ deviceModel }}
            </ng-option>
          </ng-select>
        </div>
        <div class="col-md">
          <ng-select
            class="custom"
            id="deviceManufactorSelect"
            placeholder="Fabricante"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="deviceNearbyFilter.deviceManufactorDistinct"
            [searchable]="true"
            [multiple]="true"
            (change)="filterDeviceNearby()"
            [markFirst]="true"
          >
            <ng-option
              *ngFor="
                let deviceManufactor of deviceNearby.deviceManufactorDistinct
              "
              [value]="deviceManufactor"
            >
              {{ deviceManufactor }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="card">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">
                Tipo Evento<br />DataHora Evento<br />DataHora Recebimento<br />DataHora
                Armazenamento
                <i
                  [ngClass]="
                    orderbytimestampDeviceNearbyAsc
                      ? 'uil-arrow-down'
                      : 'uil-arrow-up'
                  "
                  aria-hidden="true"
                  style="cursor: pointer"
                  (click)="
                    orderByTimestamp();
                    orderbytimestampDeviceNearbyAsc =
                      !orderbytimestampDeviceNearbyAsc
                  "
                ></i>
              </th>
              <th class="text-center" scope="col">Serial</th>
              <th class="text-center" scope="col">Modelo</th>
              <th class="text-center" scope="col">Origem Mensagem</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of deviceNearbyFilter.devices">
              <td class="text-center word-wrap" scope="row">
                <span style="color: red; font-weight: bold">{{
                  item.eventType
                }}</span
                ><br />
                {{ decodeTimestamp(item.datetimeEvent) }} <br />
                {{ decodeTimestamp(item.datetimeReceived) }} <br />
                {{ decodeTimestamp(item.datetimeStorage) }} <br />
              </td>
              <td class="text-center word-wrap" scope="row">
                {{ item.serialNumber }}
              </td>
              <td class="text-center word-wrap" scope="row">
                {{ item.deviceModel }}
              </td>
              <td class="text-center word-wrap" scope="row">
                {{ item.messageOrigin }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="map" [minHeight]="600" [fluidHeight]></div>
    </div>
  </ng-template>

  <!-- Tab TabMovidaExpressCmd-->
  <ng-template #TabMovidaExpressCmd>
    <div class="card">
      <form
        [formGroup]="movidaExpressFormGroup"
        (ngSubmit)="generateCommands()"
      >
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Placa</span>
          <input type="text" class="form-control" formControlName="plate" />
        </div>
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-text">Serial do acessório</span>
          <input
            type="text"
            class="form-control"
            formControlName="serialNumber"
          />
        </div>
        <div *ngIf="movidaExpressFormGroup.hasError('movidaExpressError')">
          <span class="text-danger">
            <ul>
              <li
                *ngFor="
                  let item of movidaExpressFormGroup.getError(
                    'movidaExpressError'
                  )
                "
              >
                {{ item }}
              </li>
            </ul>
          </span>
        </div>
        <div class="input-group input-group-sm mb-2">
          <label class="input-group-text">Senha padrão</label>
          <input
            class="ms-2"
            type="checkbox"
            (change)="
              movidaExpressFormGroup.invalid ? null : generateCommands()
            "
            formControlName="usePasswordDefault"
          />
        </div>
        <div
          class="input-group input-group-sm mb-2"
          [ngClass]="{
            'd-none': movidaExpressFormGroup.get('usePasswordDefault').value
          }"
        >
          <span class="input-group-text">Senha</span>
          <input
            type="text"
            class="form-control"
            formControlName="password"
            (change)="
              movidaExpressFormGroup.invalid ? null : generateCommands()
            "
          />
        </div>

        <ng-container *ngIf="!movidaExpressFormGroup.invalid">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Comando 1
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['comando1'].text, false);
                  movidaExpressResult['comando1'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i
              ><ng-container *ngIf="movidaExpressResult['comando1'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["comando1"].text }}</span>
          </div>

          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Comando 2
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['comando2'].text, false);
                  movidaExpressResult['comando2'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i
              ><ng-container *ngIf="movidaExpressResult['comando2'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["comando2"].text }}</span>
          </div>

          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Comando 3
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['comando3'].text, false);
                  movidaExpressResult['comando3'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i
              ><ng-container *ngIf="movidaExpressResult['comando3'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["comando3"].text }}</span>
          </div>

          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >App
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['app'].text, false);
                  movidaExpressResult['app'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i>
              <ng-container *ngIf="movidaExpressResult['app'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["app"].text }}</span>
          </div>
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Travar porta
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['lock'].text, false);
                  movidaExpressResult['lock'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i>
              <ng-container *ngIf="movidaExpressResult['lock'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["lock"].text }}</span>
          </div>
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text"
              >Destravar porta
              <i
                class="fa fa-copy ms-2"
                style="cursor: pointer"
                (click)="
                  copyToClipboard(movidaExpressResult['unlock'].text, false);
                  movidaExpressResult['unlock'].check = true
                "
                ngbTooltip="Copiar para área de transferência"
                aria-hidden="true"
              ></i>
              <ng-container *ngIf="movidaExpressResult['unlock'].check">
                <i
                  class="fa fa-check-circle ms-2"
                  style="color: green"
                  aria-hidden="true"
                ></i>
              </ng-container>
            </span>

            <span class="ms-2">{{ movidaExpressResult["unlock"].text }}</span>
          </div>
        </ng-container>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="movidaExpressFormGroup.invalid"
        >
          Gerar comandos
        </button>
        <button
          type="button"
          class="btn btn-secondary ms-2"
          (click)="movidaExpressFormClean()"
        >
          Limpar
        </button>
      </form>
    </div>
  </ng-template>

  <!-- Tab TabMovidaExpressCmd-->
  <ng-template #TabRDashboard>
    <div class="card">
      <iframe [fluidHeight] [src]="urlRdash"></iframe>
    </div>
  </ng-template>
</div>
